import { DraggerInput } from '@framework/form/inputs/upload/DraggerInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { message } from 'antd';
import type Feature from 'ol/Feature';
import { type Geometry } from 'ol/geom';
import type * as React from 'react';
import { useWatch } from 'react-hook-form';
import { type Subject } from 'rxjs';
import { type MapSubjectEvent } from '../../MapWidgetComponent.tsx';
import { geoJSONEpsg3857 } from '../../mapStyleUtils.ts';
import { MapUploadGeometriesType } from './MapUploadGeometriesSchema.tsx';

export interface IMapUploadGeometriesGeoJSONInputProps {
  mapSubject: React.RefObject<Subject<MapSubjectEvent>>;
  onClose: () => void;
  onLoadingChange: (loading: boolean) => void;
}

async function parseGeoJSON(file: File) {
  return new Promise<Array<Feature<Geometry>>>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      try {
        const parsed = geoJSONEpsg3857.readFeatures(reader.result as string);
        resolve(parsed);
      } catch (error) {
        reject(error as Error);
      }
    };
    reader.onerror = reject;
  });
}

export function MapUploadGeometriesGeoJSONInput(
  props: IMapUploadGeometriesGeoJSONInputProps,
) {
  const { mapSubject, onClose, onLoadingChange } = props;

  const selectedType: MapUploadGeometriesType | null = useWatch({
    name: 'type',
  });

  if (selectedType !== MapUploadGeometriesType.GeoJSON) return null;

  return (
    <FormItem name="files" label="File">
      <DraggerInput
        accept={'application/json'}
        showUploadList={false}
        info="È possibile caricare un file in formato GeoJSON."
        beforeUpload={async file => {
          onLoadingChange(true);
          try {
            const parsed = await parseGeoJSON(file);
            console.log(`Parsed geoJSON:`, parsed);
            mapSubject.current?.next({
              type: 'upload',
              features: parsed,
            });
            onClose();
          } catch (error) {
            message.error('Errore durante la lettura del file GeoJSON');
            console.error(error);
          } finally {
            onLoadingChange(false);
          }
          return false;
        }}
      />
    </FormItem>
  );
}
